
import Vue from 'vue';
import lozad from 'lozad';

export const lazyLoadBgImage = {
    bind(el, binding, vnode) {
        const image = binding.value;

        const setLoadingState = () => {
            this.loading = false;
        };
        el.addEventListener('load', setLoadingState);
        
        if(el){
            el.setAttribute('data-background-image', image)
            
            const observer = lozad(el);
            observer.observe();
        }
    },
  }
  
  // You can also make it available globally.
  Vue.directive('lazy-bg-image', lazyLoadBgImage)


// WEBPACK FOOTER //
// ./src/directives/LazyLoad.js